import React, { useEffect, useState } from "react";

import ErrorImage from "../../../assets/images/EmptyStateAndUpsell/error.svg";
import Card from "../../design-system/Card";
import Container, { ContainerSize } from "../../design-system/Container";
import EmptyPanel from "../../design-system/EmptyPanel";
import { logToSentry } from "../../design-system/GenericError";
import sessionId from "../session-id";

export default function ErrorPage({ error, message }: { error?: Error | null; message?: string }) {
  const [sentryErrorId, setSentryErrorId] = useState<string | undefined>(undefined);
  useEffect(() => {
    if (error) setSentryErrorId(logToSentry(error));
  }, [error]);

  return (
    <Container size={ContainerSize.Small} className="app-shell ds-p-9">
      <Card className="ds-p-5">
        <EmptyPanel heading="Unexpected error" image={ErrorImage}>
          <p>{message ?? "Please try refreshing the page."}</p>
          <p>
            If this error continues, you can
            <br />
            <a href="mailto:tickets@culture-shift.co.uk">reach out to the support team here</a>, quoting error ID{" "}
            {sentryErrorId ?? sessionId}.
          </p>
        </EmptyPanel>
      </Card>
    </Container>
  );
}
